module.exports = __webpack_public_path__ + "img/dlt_kind_2.9cb91f7e.png";